import { render, staticRenderFns } from "./calendar_event.vue?vue&type=template&id=2fdfcc7a&scoped=true&"
import script from "./calendar_event.vue?vue&type=script&lang=js&"
export * from "./calendar_event.vue?vue&type=script&lang=js&"
import style0 from "./calendar_event.vue?vue&type=style&index=0&id=2fdfcc7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdfcc7a",
  null
  
)

export default component.exports